module.exports = __webpack_public_path__ + "static/media/envelope-square.a83fa3c1.svg";